import { type OAuth2AppPermissions } from '../../../store/auth/auth'

export const isAppEnabledForUser = (permissions: OAuth2AppPermissions, userRoleIds: string[]): boolean => {
  if (!permissions.account) {
    return false
  }

  const hasAnyRoleConfig = Object.keys(permissions.systemRoles).length > 0 || Object.keys(permissions.accountRoles).length > 0
  if (!hasAnyRoleConfig) {
    return false
  }

  const userRoleSet = new Set(userRoleIds)
  const enabledInSystem = Object.entries(permissions.systemRoles).some(([roleId, enabled]) => enabled && userRoleSet.has(roleId))
  const enabledInAccount = Object.entries(permissions.accountRoles).some(([roleId, enabled]) => enabled && userRoleSet.has(roleId))
  return enabledInSystem || enabledInAccount
}
